import {
	BaseApiService,
	BaseDeleteDto,
	BaseFindDto,
	BaseFindOneDto,
	BaseUpdateDto
} from "@remar/shared/dist/api/baseApiService";
import { School } from "@remar/shared/dist/models";

import { CreateSchoolDto } from "./dto";

import { URLS } from "../services.constants";

export class SchoolsService extends BaseApiService<
	School,
	CreateSchoolDto,
	BaseFindDto,
	BaseFindOneDto,
	BaseUpdateDto<Record<string, unknown>>,
	BaseDeleteDto
> {
	constructor(baseUrl: string) {
		super(baseUrl);
	}
}

export const schoolsService = new SchoolsService(URLS.SCHOOLS);
